import { useSelector } from 'react-redux';
import { Navigate, useRoutes } from 'react-router-dom';

// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';

// login
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import ResetPassword from './pages/ResetPassword';
import ResetSuccess from './pages/ResetSuccess';

// super admin
import RestaurantList from './pages/RestaurantList';
import RestaurantAdminList from './pages/UserList'
import AdminDashboard from './pages/AdminDashboard';
import AdminList from './pages/AdminList';

// ----------------------------------------------------------------------
const RoutesProvider = () => {

  const { isAuthenticated, user} = useSelector((state) => state.adminUser)
  const routes = useRoutes([
    {
      path: '/',
      element: isAuthenticated ? <DashboardLayout /> : <Navigate to={"/login"} />,
      children: [
        { element: <Navigate to={`dashboard`} />, index: true },
        { path: 'dashboard', element: <AdminDashboard /> },
        { path: 'admin', element: user?.role === "superadmin" ? <AdminList /> : null },
        { path: 'restaurant', element: <RestaurantList /> },
        { path: 'user', element: <RestaurantAdminList /> },

      ],
    },
    {
      path:'/',
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to={`/login`} />, index: true },
        {
          path: 'login',
          element: <LoginPage />,
        },
        {
          path: 'forget-password',
          element: <ResetPassword />,
        },
        {
          path: 'reset-password/success',
          element: <ResetSuccess />,
        },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
  ]);

  return routes;
}
export default RoutesProvider;